export default __webpack_public_path__ + "static/TeslaMockup-e2b16332263a059e251acc53fd67c5bb.png";